var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.user.approved)?_c('chat',{attrs:{"user":_vm.user}}):_c('h1',[_vm._v(_vm._s(_vm.$t('master.unapprovedUser')))])}
var staticRenderFns = []

export { render, staticRenderFns }